<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'uploadOrder'+order.id">
      <slot></slot>
    </span>
    <el-dialog top="0" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
      <h3 class="text-center">下单信息</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div style="display:flex;justify-content: space-between;max-height: 73vh;">
          <div style="height:100%;width:45%;max-height:73vh;overflow-y: auto;">
            <template v-if="order.type==2">
              <ul v-if="order.type==2" class="noBorder">
                <li v-for="(good,index) in goods_info"  class="good_info">
                  <el-row >
                    <el-col :span="6">
                        <img v-if="!good.image" src="../../../../ico/uploadpic@2x.png"  @click="showOrderVoucher(index)"/>
                        <img v-else :src="good.image"  @click="showOrderVoucher(index)"/>
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </template>
            <template v-else>
              <div v-if="groupOrderLine.length==1 && groupOrderLine[0].number==1">
                <div class="img-container">
                  <img v-if="groupOrderLine[0].picture" :src="groupOrderLine[0].picture"/>
                  <img  v-else src="https://pic.joyorders.com/blank.png"/>
                </div>
                <div class="line-des">
                  <p class="name">{{groupOrderLine[0].name}}</p>
                  <p>
                    <span v-show="!groupOrderLine[0].isHideSpecLabel">规格：</span>
                    <span v-html="formatSpec(groupOrderLine[0].spec,groupOrderLine[0])"></span>
                  </p>
                  <p><span>数量：</span>{{groupOrderLine[0].number}}</p>
                </div>
              </div>
              <div style="height:100%;" v-else>
                <ProductList v-if="groupOrderLine.length>0" ref="ProductList" :numEditable="true" :groupOrderLine="groupOrderLine" :order="order" :operation="'下单'"></ProductList>
              </div>
            </template>
          </div>
          <div style="width:45%">
            <el-form-item prop="business_order_no">
              <YueDanIpt model="business_order_no" :object="form" placeholder="商家订单号"></YueDanIpt>
            </el-form-item>
            <el-form-item prop="business_order_url">
              <YueDanIpt model="business_order_url" :object="form" placeholder="商家订单链接"></YueDanIpt>
            </el-form-item>
            <el-form-item prop="merchant_account">
              <div style="display:flex;justify-content: space-between;">
                <div style="width:48%;">
                  <YueDanIpt model="merchant_account" :object="form" placeholder="下单账号/邮箱"></YueDanIpt>
                </div>
                <div style="width:48%;">
                  <el-select style="width:100%;height:50px;"
                          v-model="transport_express"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="input-width customheight_auto"
                          @change="transporthandleSelect"
                          placeholder="转运公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
                        </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="transport_express_id" v-if="order.service_type == 2">
              <div style="margin-bottom:5px;line-height: normal;">商家委托|转运委托</div>
              <div style="display:flex;justify-content: space-between;">
                <div style="width:48%;">
                  <el-select clearable
                  filterable
                  :filter-method="remoteSellerDelegateSearch"
                  class="customheight_auto" style="width:100%;"
                  v-model="seller_delegate" placeholder="商家发货委托人">
                            <el-option
                              v-for="item in sellerdelegates"
                              :key="item.account_id"
                              :label="item.username"
                              :value="item.account_id">
                            </el-option>
                  </el-select>
                </div>
                <div style="width:48%;" v-if="order.service_type == 2 && normal_address_show">
                  <el-select filterable
                  :filter-method="remoteTransportDelegateSearch"
                  class="customheight_auto" style="width:100%;"
                  v-model="transport_delegate" placeholder="转运发货委托人">
                    <el-option
                      v-for="item in transportdelegates"
                      :key="item.account_id"
                      :label="item.username"
                      :value="item.account_id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="transport_express_id">
              <div style="margin-bottom:5px;line-height: normal;">支付方|支付方式
                
              </div>
              <div style="display:flex;justify-content: space-between;">
                <div style="width:48%;">
                  <el-select 
                  class="customheight_auto" style="width:100%;"
                  v-model="form.payment_username" placeholder="支付方">
                      <el-option
                      v-for="item in payment_username_arr"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div style="width:48%;">
                  <el-select 
                  class="customheight_auto" style="width:100%;"
                  v-model="form.payment_type_list" placeholder="支付方式">
                    <el-option
                      v-for="item in payment_type_list_arr"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <!--<el-form-item prop="transport_express_id" v-if="order.service_type == 2">
              <el-select style="width:100%;height:50px;"
                          v-model="transport_express_account"
                          clearable
                          filterable
                          :filter-method="remoteAccountSearch"
                          class="input-width customheight_auto"
                          @change="accountSelect"
                          placeholder="转运公司账号">
                          <el-option
                            v-for="item in remoteAccountOptions"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
                        </el-select>
            </el-form-item>-->
            <!--<el-form-item>
              <el-input type="textarea" :rows="2" placeholder="申报提示描述(选填)" v-model="form.exception_desc"></el-input>
            </el-form-item>-->
            <div>
              <el-button :loading="loading" style="margin:20px 0 10px;" class="block" type="primary" @click="submitAndUpload()">提交并上传凭证</el-button>
              <el-button :loading="loading" style="margin-bottom:20px;" class="block" type="default" @click="submit()">提 交</el-button>
            </div>
          </div>
        </div>      
      </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
import YueDanIpt from '../../../../components/YueDanIpt'
import ProductList from './ProductList'
import { formatSpec } from '../../../../services/tools.js'
import { SPEC_MAPPER,specOrder } from '../../../../services/constant.js'
let _ = require('lodash')

export default {
  name: 'UploadOrderNo',
  props: ['order', 'isSingle','mobiletype','expressList','delegates','normal_address_show','totalAccountList','singleList'],
  components: {
    YueDanIpt: YueDanIpt,
    ProductList:ProductList
  },
  computed: {
    globalUserInfo() {
        return this.$store.state.userInfo
    },
    single_type () {
	    return this.$store.state.single_type
    },
  },
  data () {
    return {
      payment_username_arr:[],
      payment_type_list_arr:[
        {value:'1',name:'礼卡'},{value:'2',name:'Paypal'},
        {value:'3',name:'银行卡'},{value:'4',name:'支付宝'},
        {value:'5',name:'微信'},{value:'1,2',name:'礼卡+Paypal'},{value:'1,3',name:'礼卡+银行卡'},
        {value:'',name:'无'}
      ],
      formatSpec:formatSpec,
      groupOrderLine:[],
      goods_info:[],
      accountOptions:[],
      remoteAccountOptions:[],
      remoteTrasports:[],
      transport_delegate:'',
      seller_delegate:'',
      sellerdelegates:[],
      transportdelegates:[],
      settings:{},
      transport_express:'',
      transport_express_account:'',
      dialogFormVisible: false,
      isEmptyErrors: true,
      errors: null,
      form: {
        business_order_no: null,
        business_order_url:'',
        transport_express_id:null,
        transport_express_account:null,
        merchant_account:'',
        exception_desc:'',
        payment_username:this.single_type==2?this.globalUserInfo.username:'Joy',
        payment_type_list:'1'
      },
      account_id:this.$localStorage.get('account_id'),
      loading: false,
      rules: {
        business_order_no: [
          // { required: true, message: '商家订单号是必填项', trigger: 'blur' }
        ]
      },
      combinedelegates:[]
    }
  },
  methods: {
    async show () {
      if(this.single_type==2){
        this.payment_username_arr=[{value:'',name:''},{value:this.globalUserInfo.username,name:this.globalUserInfo.username}]
      }
      else{
        this.payment_username_arr=[{value:'',name:''},{value:'Joy',name:'Joy'},{value:this.globalUserInfo.username,name:this.globalUserInfo.username}]
        //if(this.order.business_id=='4474' || this.order.business_id=='4486')
        if(this.order.business.country.toLowerCase()=='ca')
          this.payment_username_arr.push({value:'Anniee2Joy',name:'Anniee2Joy'})
      }
      if(this.order.buyer_delegate_username && this.payment_username_arr.filter(i=>i.name.toLowerCase()==this.order.buyer_delegate_username.toLowerCase()).length==0)
        this.payment_username_arr.push({value:this.order.buyer_delegate_username,name:this.order.buyer_delegate_username})
      this.groupOrderLine = []
      if(this.order.type==2){
        this.goods_info=[]
        this.order.good_image_list.forEach((g)=>{
          this.goods_info.push({id:new Date().getTime(),image:g,remark:''})
        })
      }
      else{
        let l = []
        if(this.$store.state.curPackageId)
          l = this.order.goods_list.filter(i=>i.package_id == this.$store.state.curPackageId)
        else
          l = this.order.goods_list
        _.each(l, item => {
          item.checked = true
          if (item.status == 0) {
            this.groupOrderLine.push(item)
          }
        })
        if(this.groupOrderLine.length==1 && this.groupOrderLine[0].number==1){
          this.groupOrderLine[0].selectNum=1
          this.groupOrderLine[0].checked = true
        }
      }

      this.combinedelegates=this.uniqueObjects(this.delegates.concat(this.singleList.map((i)=>{return {account_id:i.id,username:i.name}})))
      let isModify=sessionStorage.getItem('isModifyUpload')
      this.dialogFormVisible = true
      this.$store.commit('updateOpenDialog', true)
      this.sellerdelegates=[]
      this.transportdelegates=[]
      /*if(!this.delegates.length){
        let res = await api.getShipDelegateList(this)
        if(res.body.status=='ok')
          this.delegates=res.body.result
      }*/

      this.settings=JSON.parse(localStorage.getItem(this.account_id))
      if(!this.settings)
        this.settings={}
      /*if(this.order.business_order_no){
        this.form.business_order_no=this.order.business_order_no
      }*/
      //处理初始账号邮箱
      if(isModify=='true'){
        this.form.merchant_account=this.order.merchant_account
      }
      else{
        if(this.settings[this.order.business_id] && this.settings[this.order.business_id].merchant_account){
          this.form.merchant_account=this.settings[this.order.business_id].merchant_account
        }
      }
      //处理初始的支付方和支付方式
      if(this.settings[this.order.business_id] && this.settings[this.order.business_id].payment_username && this.payment_username_arr.indexOf(this.settings[this.order.business_id].payment_username)>-1)
        this.form.payment_username=this.settings[this.order.business_id].payment_username
      if(this.settings[this.order.business_id] && this.settings[this.order.business_id].payment_type_list)
        this.form.payment_type_list=this.settings[this.order.business_id].payment_type_list
      //处理初始的转运公司id
      this.transport_express=''
      let old_transport_express=''
      if(this.order.transport_express_id && this.order.transport_express_id!='0'){
        old_transport_express=this.order.transport_express_id;
      }
      else if(this.order.service_type==2){
        old_transport_express=this.settings[this.order.business_id] && this.settings[this.order.business_id].transport_express?this.settings[this.order.business_id].transport_express:'';
      }
      if(old_transport_express){
          this.remotetransportSearch('',()=>{
            this.transport_express=old_transport_express
            this.form.transport_express_id=this.transport_express;
            this.transportSelect=true;
          })
      }
      if(this.transport_express){
        let res = await api.getExpressAdminAccountList(this,{express_company_id:this.transport_express})
          //let arr = this.bindedAccountList.filter(i=>i.express_company_id==item);
          let arr = res.body.result
          //console.log('item',this.combinedelegates,arr)

          for(let i=0;i<arr.length;i++){
            if(this.combinedelegates.filter(s=>s.account_id==arr[i].account_id).length){
              this.sellerdelegates=this.combinedelegates.filter(s=>s.account_id==arr[i].account_id)            
              this.seller_delegate=arr[i].account_id
              this.transportdelegates=this.combinedelegates.filter(s=>s.account_id==arr[i].account_id)            
              this.transport_delegate=arr[i].account_id
            }
          }
      }
      else{
        //处理初始的商家委托id
        this.seller_delegate=''
        if(this.order.business_shipping_account_id && this.order.business_shipping_account_id!='0'){
          this.seller_delegate=this.order.business_shipping_account_id;
        }
        else{
          this.seller_delegate=this.settings[this.order.business_id] && this.settings[this.order.business_id].seller_delegate?this.settings[this.order.business_id].seller_delegate:'';
        }
        if(this.seller_delegate){
          let o=this.combinedelegates.filter(i=>i.account_id==this.seller_delegate)
          this.sellerdelegates=o
        }
        this.sellerdelegates=this.sellerdelegates.concat([{account_id:-1,username:'暂不委托'}])
        //处理初始的转运委托id
        this.transport_delegate=''
        if(this.order.transport_shipping_account_id && this.order.transport_shipping_account_id!='0'){
          this.transport_delegate=this.order.transport_shipping_account_id;
        }
        else{
          this.transport_delegate=this.settings[this.order.business_id] && this.settings[this.order.business_id].transport_delegate?this.settings[this.order.business_id].transport_delegate:'';
        }
        if(this.transport_delegate){
          let o=this.combinedelegates.filter(i=>i.account_id==this.transport_delegate)
          this.transportdelegates=o
        }
        this.transportdelegates=this.transportdelegates.concat([{account_id:-1,username:'暂不委托'}])
      }
      sessionStorage.removeItem('isModifyUpload')

      this.getAccountList()
    },
    getAccountList(){
      let tid=0;
      if(this.transport_express && this.transport_express!='0'){
        tid=this.transport_express
        if(this.transport_express==1542)
          tid=901
      }
      else if(this.order.business_id=='4474'){
        tid=899
      }
      if(tid){
        this.accountOptions=this.totalAccountList.filter(i=>i.express_company_id==tid).map((a)=>{
          return {value:a.account_name,id:a.account_id}
        })
      }
      else
        this.accountOptions=[]
    },
    init () {
      this.form.business_order_no = null
      this.form.business_order_url = ''
      this.errors = null
      this.isEmptyErrors = true
      this.$store.commit('updateOpenDialog', false)
      console.log('aaa',this.form.business_order_no)
    },
    async transportquerySearch(queryString, cb){
      let query = {
        keyword: queryString
      }
      //let res = await api.getExpressList(this,query)
      let res=this.expressList.filter((i)=>{
        return i.name.indexOf(query)>-1
      })
      let arr = []
      _.each(res,item => {
        if(item.type == '2') {
          arr.push({value:item.name,id:item.id})
        }
      })
      cb(arr)
      this.transportSelect = false
      this.form.transport_express_id = null
      this.errors = null
      this.isEmptyErrors = true
    },
    uniqueObjects(arr) {
      const unique = new Set();
      return arr.filter((obj) => {
        const stringKey = JSON.stringify(obj);
        const found = unique.has(stringKey);
        unique.add(stringKey);
        return !found;
      });
    },
    remoteSellerDelegateSearch(queryString){
      if(queryString==''){
        this.sellerdelegates=[{account_id:-1,username:'暂不委托'}]
      }
      else{
        this.sellerdelegates=this.combinedelegates.filter(i=>i.username.toLowerCase()==queryString.toLowerCase())
      }
    },
    
    remoteTransportDelegateSearch(queryString){
      if(queryString==''){
        this.transportdelegates=[{account_id:-1,username:'暂不委托'}]
      }
      else{
        this.transportdelegates=this.combinedelegates.filter(i=>i.username.toLowerCase()==queryString.toLowerCase())
      }
    },
    
    async remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      /*let query = {
        keyword: queryString
      }*/
      //let res = await api.getExpressList(this,query)
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
          //this.form.express = item.id
        }
      })
      this.transportSelect = false
      this.form.transport_express_id = null
      this.errors = null
      this.isEmptyErrors = true
      if(callback)
          callback()
    },
    async transporthandleSelect (item) {
        this.form.transport_express_id = item
        this.remoteAccountOptions=[]
        this.transport_express_account = ''
        if(item){
          let res = await api.getExpressAdminAccountList(this,{express_company_id:item})
          //let arr = this.bindedAccountList.filter(i=>i.express_company_id==item);
          let arr = res.body.result
          console.log('item',this.combinedelegates,arr)

          for(let i=0;i<arr.length;i++){
            if(this.combinedelegates.filter(s=>s.account_id==arr[i].account_id).length){
              this.sellerdelegates=this.combinedelegates.filter(s=>s.account_id==arr[i].account_id)            
              this.seller_delegate=arr[i].account_id
              this.transportdelegates=this.combinedelegates.filter(s=>s.account_id==arr[i].account_id)            
              this.transport_delegate=arr[i].account_id
            }
          }
          this.getAccountList();
        }
        this.transportSelect = true
    },
    async remoteAccountSearch(queryString,callback){
      this.remoteAccountOptions=this.accountOptions.filter((i)=>{
        return i.value.indexOf(queryString)>-1
      })
      
      //this.form.transport_express_account = null
      if(callback)
          callback()
    },
    accountSelect (item) {
        this.form.transport_express_account = item
    },
    submitAndUpload(){
      this.submit(true)
    },
    submit(needUpload) {
      if(this.form.business_order_no){
        let reg = /[a-zA-Z0-9\-\.\_]+\b$/
        // let d = this.form.business_order_no
        if(!reg.test(this.form.business_order_no) || this.form.business_order_no.length >= 101 || this.form.business_order_no.indexOf('|')>-1){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的商家订单号,必须包含字母或数字,可以包含-,_和.,不能包含|,不超过100个字符'}
            ]
          }
          return
        }
      }
      
      let order_nos = this.order.goods_list.map(g=>g.business_order_no)
      if(order_nos.indexOf(this.form.business_order_no)>-1){
        this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '订单号与其他包裹的订单号重复'}
            ]
          }
          return
      }
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors

        if (valid) {
          let goods_list = []
          if(this.order.type==2){
            this.goods_info.forEach((line)=>{
              goods_list.push({
                id: line.id,
                num: 1
              })
            })
          }
          else{
            _.each(this.groupOrderLine, line => {
              if (line.checked) {
                goods_list.push({
                  id: line.id,
                  num: line.selectNum
                })
              }
            })
          }
          if(!goods_list.length){
            this.isEmptyErrors = false
            this.errors = {
              business_name: [
                {message: '请至少选择一件商品'}
              ]
            }
            return
          }
          let data={
              order_id: this.order.id,
              business_order_no: this.form.business_order_no,
              transport_express_id: this.form.transport_express_id,
              business_order_url: this.form.business_order_url,
              transport_express_account: this.form.transport_express_account,
              update_time: this.order.update_time,
              merchant_account:this.form.merchant_account,
              payment_username:this.form.payment_username,
              payment_type_list:this.form.payment_type_list,
              goods_list:goods_list
            }
          if(this.seller_delegate!=-1){
            data.business_shipping_account_id=this.seller_delegate
          }
          if(this.transport_delegate!=-1){
            data.transport_shipping_account_id=this.transport_delegate
          }
          let res = await api.post(this, {
            path: 'order.php',
            api: 'upload_info',
            data: data,
            loading: 'loading'
          })
          res = res.body
          if(res.status == 'error'){
            if(res.result == 'business_order_no_exist'){
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  {message: '此订单号已存在'}
                ]
              }
            }
            else if(res.result == 'already_updated'){
              this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
                confirmButtonText: '确定',
                callback: action => {
                  this.dialogFormVisible = false           
                  Object.assign(this.order, res.description)
                  if(this.order.goods_list && this.order.goods_list.length)
                    this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
                }
              })
            }
            return
          }
          if (res.status == 'ok') {
            if(!this.settings){
              this.settings={}
            }
            if(!this.settings[this.order.business_id]){
              this.settings[this.order.business_id]={};
            }
            if(this.seller_delegate)
              this.settings[this.order.business_id].seller_delegate=this.seller_delegate
            if(this.order.service_type==2)
              this.settings[this.order.business_id].transport_express=this.form.transport_express_id
            this.settings[this.order.business_id].merchant_account=this.form.merchant_account
            
            if(this.order.service_type==2){
              if(this.transport_delegate)
                this.settings[this.order.business_id].transport_delegate=this.transport_delegate
            }
            this.settings[this.order.business_id].payment_type_list=this.form.payment_type_list;
            this.settings[this.order.business_id].payment_username=this.form.payment_username;
            localStorage.setItem(this.account_id,JSON.stringify(this.settings));  
            this.dialogFormVisible = false      
            Object.assign(this.order, res.result)
            this.order.goods_list=res.result.goods_list
            if(this.order.goods_list && this.order.goods_list.length){
              _.each(this.order.goods_list, good => {
                if (good.status == 3 || good.status == 7) {
                  good.package_id = good.cancel_time
                }
              })
            }
            this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
            if(this.form.exception_desc.trim()){
              let data={
                order_id: this.order.id,
                type:9,
                description:this.form.exception_desc,
                product_list:[]
              }
              
              let res = await api.post(this, {
                path: 'order_exception.php',
                api: 'add',
                data: data,
                loading: 'loading'
              })
              res = res.body
              if (res.status == 'ok') {
                this.order.exception_list=res.result
              }
            }
            let data = {
              status: null,
              operationType: '上传下单信息成功',
              operation: '上传',
              needRefreshPackStatus:false
            }
            if(needUpload)
              data.needUpload=true
            this.form.business_order_no=null
            this.form.business_order_url = ''
            this.$emit('complete', data)
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .mobile_upload_order {
    padding: 0 10px !important;
  }
  .clearHistory{
    float: right;
    padding:0;
    font-size: 14px;
    color:#1066CF;
  }
  .img-container {
      float: left;
      width: 100px;
      height: 100px;
      overflow: hidden;
      img {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }
    }
    .line-des {
    margin-left: 130px;
    position: relative;
    top:-6px;
    p {
      line-height: 24px;
      word-break: break-all;
      span {
        color: #888888;
      }
    }
  }
  ul {
    margin-top: 10px;
    max-height: 286px;
    overflow-y: auto;
    overflow-x: hidden;
    &.noBorder{
      border-bottom:none !important;
    }
    .good_info{
      position: relative;
      border: 1px solid #ccc;
      margin-top: 20px;
      &:first-child{
        margin-top: 0px;
      }
      .delete {
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 10px;
      }
      img {
        padding: 10px;
        height: 90px;
        width: 90px;
        // -o-object-fit: contain;
        object-fit: contain;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/UploadOrderDialog.vue